// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__30395","top":"styles_top__1xmqP"};